var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patrolPlanDetails commonWrap"},[_c('div',{staticStyle:{"width":"98%","height":"97%"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"height":"100%","border":"","stripe":"","header-cell-style":{
        'font-weight': 'bold',
        color: '#333',
        'background-color': '#F7F7F7',
      },"cell-style":_vm.cellStyle},on:{"cell-click":_vm.cellClick}},_vm._l((_vm.tabHead),function(v,i){return _c('el-table-column',{key:i,attrs:{"prop":v.prop,"label":v.label,"align":"center"}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }